// A $( document ).ready() block.
// $( document ).ready(function() {
//   console.log("helloo")
//     const swiper = new Swiper('.product-card-swiper', {
//         slidesPerView: 'auto',
//             allowTouchMove: false, // disable swipe

//     mousewheel: false, // disable mouse wheel

//       pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//       },

//       navigation: {
//         nextEl: '.cstm-swiper-button-next',
//         prevEl: '.cstm-swiper-button-prev',
//       },
//     });


// });


$(document).ready(function () {
  function initProductSwiper(el) {
    if (el.classList.contains('swiper-initialized')) return; // don't double-init

    new Swiper(el, {
      slidesPerView: 'auto',
      allowTouchMove: false,
      mousewheel: false,
      observer: true,
      observeParents: true,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 4,
      },
      navigation: {
        nextEl: el.querySelector('.cstm-swiper-button-next'),
        prevEl: el.querySelector('.cstm-swiper-button-prev'),
      },
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('.product-card-swiper').forEach(initProductSwiper);
  }

  // 1) Init any swipers already on the page (your working product cards,
  //    and recommendations if they happened to load before ready)
  initAll();

  // 2) Watch the recommendations element — it injects its cards later
  document.querySelectorAll('product-recommendations').forEach((recs) => {
    const observer = new MutationObserver(() => initAll(recs));
    observer.observe(recs, { childList: true, subtree: true });
  });
});